import { dateFormat } from "../../../../utils/tableUtils";
import AccountProfileAvatar from "./AccountProfileAvatar";

const LeftAccountBox = ({ account }: any) => (
  <AccountProfileAvatar
    name={account?.name}
    lastSeen={account?.last_seen && dateFormat("normal", account.last_seen)}
    totalUsers={account?.total_user_count}
    img={account?.avatar_url}
    id={account?.external_id}
    joined={account?.record_created_at && dateFormat("normal", account.record_created_at)}
  />
);

export default LeftAccountBox;
